import { useMemo } from 'react';
import styled, { css } from 'styled-components';

import LoadingCircle from '~components/Loading';
import CardTitle from '~features/company/CardTitle';
import CompanyLogoCard from '~features/company/CompanyLogoCard';
import ErrorSection from '~features/company/ErrorSection';
import { useGetCompanyRelations } from '~hooks/query/company/useCompanyRelations';
import { useRouterQuery } from '~hooks/useRouterQuery';

export default function CompanyRelations() {
  const companyId = useRouterQuery('companyId');
  const { data: companyRelations, status: statusCompanyRelations } =
    useGetCompanyRelations(companyId);

  const title = useMemo(() => {
    if (companyRelations?.type === 'LIVE') {
      return '실시간 검색 기업';
    }

    return '연관 기업';
  }, [companyRelations]);

  if (statusCompanyRelations === 'error') {
    return (
      <>
        <CardTitle>{title}</CardTitle>
        <ErrorSectionWrapper>
          <ErrorSection />
        </ErrorSectionWrapper>
      </>
    );
  }

  if (statusCompanyRelations === 'loading' || !companyRelations) {
    return <LoadingCircle />;
  }

  return (
    <>
      <CardTitle>{title}</CardTitle>
      <CardContainer>
        {[...companyRelations.companies].splice(0, 4).map((company) => (
          <CompanyLogoCard
            key={`relations-${company.id}`}
            companyId={company.id}
            location={company.location}
            locationCode={company.locationCode}
            companyName={company.name}
            PK_NM_HASH={company.PK_NM_HASH}
            href={`/company/${company.PK_NM_HASH}`}
            inlineCss={cssCard}
            data-attribute-id='company__search__click'
            data-search-value={company.name}
            data-search-type={companyRelations?.type === 'LIVE' ? '실시간검색' : '연관검색'}
          />
        ))}
      </CardContainer>
    </>
  );
}

const ErrorSectionWrapper = styled.div`
  padding: 108px 0;

  ${({ theme }) => theme.media.mobile} {
    padding: 0;
  }
`;

const CardContainer = styled.div`
  display: grid;
  margin-top: 30px;
  gap: 15px;
  grid-template-columns: 1fr 1fr;

  ${({ theme }) => theme.media.pc} {
    margin-top: 0;
    gap: 20px;
    margin-top: 40px;
    grid-template-columns: inherit;
  }
`;

const cssCard = css`
  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.media.mobile} {
    padding-right: 10px;
  }
`;
